export default function CantidadSelector({ cantidad, setCantidad }) {
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={() => setCantidad((c) => Math.max(1, c - 1))}
        className="bg-red-500 px-3 rounded"
      >
        -
      </button>

      <span className="font-bold">{cantidad}</span>

      <button
        onClick={() => setCantidad((c) => c + 1)}
        className="bg-green-500 px-3 rounded"
      >
        +
      </button>
    </div>
  );
}
